import { createFileRoute } from "@tanstack/react-router";
import Customers from "@/pages/Customers";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/zh/customers")({
  head: () => pageHead("/customers", "zh"),
  component: Customers,
});
